import { shippingClient } from 'domain/HttpClients';

export const fetch = (shipmentId) => shippingClient.Get(`/api/shipments/trackshipment/${shipmentId}`).send();
